<ngx-smart-modal
  class="form-widget-popup"
  [id]="'formWidgetPopup'"
  #formWidgetPopup
  [identifier]="'formWidgetPopup'"
  [style]="{
    height: '580px',
    maxHeight: '600px',
    width: '470px',
    maxWidth: '470px'
  }"
  [dismissable]="false"
  [closable]="false"
>
  <div class="popup-content-wrapper p-4">
    <div class="header text-center">
      <h1 class="mb-0 typog-h5 text-center">Link to Form ID</h1>
      <p class="typog-sm mb-0 text-grey">
        Type a new name to create a new Form ID, or select an existing one from the dropdown
      </p>
    </div>
    <div [formGroup]="formGroup" class="popup-content my-4 px-3">
      <p-autoComplete
        formControlName="formId"
        [suggestions]="filteredFormsList"
        (completeMethod)="getFilteredForms($event)"
        (onSelect)="setSelectedForm($event)"
        (keydown)="onKeydown($event)"
        [minLength]="1"
        class="autocomplete w-100"
        [placeholder]="'Enter Form Name'"
        [dropdown]="true"
      >
      </p-autoComplete>

      <div *ngIf="selectedFormDescription" class="mt-2 typog-md d-flex gap-1 text-grey">
        <span><mat-icon svgIcon="info-circle"></mat-icon></span><span>{{ selectedFormDescription }}</span>
      </div>

      <span
        *ngIf="formGroup.get('formId')?.touched && formGroup.controls['formId']?.hasError('required')"
        class="typog-xs text-error"
      >
        Field is required.</span
      >
    </div>
    <div class="popup-footer">
      <hr class="divide-footer ml-4 mr-4 mb-5 mt-0" />
      <div class="col-12 text-center mt-5">
        <button type="button" (click)="cancel()" class="mr-4">Cancel</button>
        <button type="button" (click)="onSubmit()" class="positive">OK</button>
      </div>
    </div>
  </div>
</ngx-smart-modal>
